import { render } from "./Signin.vue?vue&type=template&id=72925050"
import script from "./Signin.vue?vue&type=script&lang=js"
export * from "./Signin.vue?vue&type=script&lang=js"

import "./Signin.vue?vue&type=style&index=0&id=72925050&lang=scss"

import exportComponent from "D:\\Code\\word\\anyRTC\\anyrtc_synergy\\Synergy-Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__